import React from 'react';
import { Link } from 'react-router-dom';
import BrandCross from './BrandCross';
import { useI18n } from '../i18n/LanguageContext';

const COLUMNS = [
  {
    title: 'footer.features',
    links: [
      { label: 'footer.payment', to: '/payment' },
      { label: 'footer.card', to: '/card' },
      { label: 'footer.transport', to: '/transport' },
    ],
  },
  {
    title: 'footer.features',
    links: [
      { label: 'footer.payment', to: '/payment' },
      { label: 'footer.card', to: '/card' },
      { label: 'footer.transport', to: '/transport' },
    ],
  },
  {
    title: 'footer.security',
    links: [
      { label: 'footer.terms', to: '/terms' },
      { label: 'footer.conditions', to: '/conditions' },
      { label: 'footer.privacy', to: '/privacy' },
    ],
  },
];

export default function Footer() {
  const { t } = useI18n();
  const year = new Date().getFullYear();
  return (
    <footer className="site-footer">
      <div className="site-footer-main">
        <div className="site-footer-brand">
          <Link to="/" className="brand brand--footer" aria-label="Indabo za Mariya home">
            <BrandCross />
            <span className="brand-name">INDABO ZA MARIYA</span>
          </Link>
          <p className="site-footer-tagline">{t('footer.tagline')}</p>
        </div>
        <div className="site-footer-cols">
          {COLUMNS.map((col, i) => (
            <div key={i} className="site-footer-col">
              <div className="site-footer-col-title">{t(col.title)}</div>
              <ul>
                {col.links.map((link) => (
                  <li key={link.label}>
                    <Link to={link.to}>{t(link.label)}</Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
      <div className="site-footer-bottom">
        <span>{t('footer.copyright', { year })}</span>
        <a href="/privacy">{t('footer.data_privacy')}</a>
      </div>
    </footer>
  );
}
